export class Settings {
	public constructor(settings: any) {
		Object.assign(this, settings);
	}
}
export interface Settings {
	base: string;
	url(url: string): string;
	name: string;
	author: string;
	description: string;
	minDate: string;
	mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
	errorPages: {
		default: { icon: [string, string]; title: string; message: string; statusCode: number };
		[code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
	};
	card: string;
	headerLogo: string;
    dialogBoxImage: string;
    headerLogoRebrevant: string;
	headerLogoStelaraStandard : string;
	leftLogo: string;
	rightLogo: string;
    rightLogoRebrevant:string;
    rightLogoRemicade:string;
	rightLogoSimponiAria: string;
    rightLogoInlexzo: string;
    rightLogoImaavy: string;
	rightLogoIcotyde: string;
	footerLogo: string;
    rebateStelaraStandard:string;
	cardTypeQuestionId: string;
	cardTypeAnswerId: string;
	programId: string;
	surveyId: string;
	eligibilityFederalQuestion: string;
	eligibilityFederalAnswer: string;
	eligibilityCitizenQuestion: string;
	eligibilityCitizenAnswer: string;
	eligibilityAgeQuestion: string;
	eligibilityAgeAnswer: string;
	triangleUp: string;
	triangleDown: string;
	lockEnabled: string;
	lockPassword: string;
	rebateTremfya: string;
    clickTremfyaRebateForm: string;
	rebateStelara: string;
	rebateStelaraFront: string;
	rebateStelaraBack: string;
    rebateMm1:string;
	rebateSimponiAriaMedical: string;
	rebateSimponiAriaPharmacy: string;
	rebateMedicalStelara: string;
    rebateStelaraStandardLeft: string;
    rebateStelaraStandardRight: string;
	rebateTremfyaLeft: string;
	rebateTremfyaRight: string;
	rebateErleada: string;
	rebateOpsumit: string;
	rebateSimponi: string;
    rebateInlexzo: string;
	rebateInlexzoFront: string;
	rebateInlexzoBack: string;
	rebateImaavyMedical: string;
	rebateImaavyPharmacy: string;
	rebateImaavy: string;
	rebatePh: string;
	rebateRybrevant: string;
	sessionTimeout: number;
    needHelpImage: string;
    needHelpPHImage: string;
	rebateMedicalTremfyaStandard:string;
	rebatePharmacyTremfyaStandard:string
	rebateMedicalTremfyaFront : string
	rebatePharmacyTremfyaFront : string
	rebatePharmacyTremfyaBack : string
	rebateRemicadeMedical:string;
	rebateRemicadePharmacy:string;
    rebateFormRybrevant: string;
	rebateIcotyde: string;
    JNJLogoStackedRedRGB:string;
    jnjStackedLogo: string;
    tremfyaRebateForm: string;
}
